/** Repair a mismatched GFM separator so saved research tables remain readable. */
export function normalizeMarkdownTables(markdown: string): string {
  const lines = markdown.split(/\r?\n/);
  let inFence = false;

  for (let index = 0; index < lines.length - 1; index++) {
    const line = lines[index].trim();
    if (/^(`{3,}|~{3,})/.test(line)) {
      inFence = !inFence;
      continue;
    }
    if (inFence) continue;

    const header = pipeCells(line);
    const separator = pipeCells(lines[index + 1].trim());
    if (!header || !separator || header.length === separator.length) continue;
    if (!separator.every((cell) => /^:?-{3,}:?$/.test(cell))) continue;

    const fixed = separator.slice(0, header.length);
    while (fixed.length < header.length) fixed.push("---");
    lines[index + 1] = `|${fixed.join("|")}|`;
  }

  return lines.join("\n");
}

function pipeCells(line: string): string[] | null {
  if (!line.startsWith("|") || !line.endsWith("|")) return null;
  return line.slice(1, -1).split("|").map((cell) => cell.trim());
}
